<script>

import AppointmentItem from '@/components/appointment/AppointmentItem.vue'
import UnavailabilityItem from '@/components/agenda/UnavailabilityItem.vue'
import AppointmentForm from '@/components/appointment/AppointmentForm.vue'
import AvailabilityButton from '@/components/availability/AvailabilityButton.vue'
import Control from '@/components/agenda/Control.vue'
import CurrentTime from '@/components/agenda/CurrentTime.vue'
import '@vuepic/vue-datepicker/dist/main.css'
//import EventBus from "../common/EventBus"
import appointmentService from "@/services/appointment.service"
import unavailabilityService from "@/services/unavailability.service"
import api from "@/services/api"
import VueDatepicker from '@vuepic/vue-datepicker'
import moment from 'moment'
import PeriodService from '@/services/period.service'
import Icon from "@/components/Icon/Icon.vue"
import { ref } from "vue";
import userService from "@/services/user.service"
import RightsEnum from "@/enum/rights.enum"

export default {
    name: 'AgendaPage',
    components: {
        AppointmentItem,
        UnavailabilityItem,
        AppointmentForm,
        AvailabilityButton,
        Control,
        CurrentTime,
        VueDatepicker,
        Icon,
    },
    data() {
        return {
            daysAppointments: {},
            showModal: false,
            appointmentData: {},
            currentdate: [moment().startOf('isoweek').format('YYYY-MM-DD'), moment().endOf('isoweek').format('YYYY-MM-DD')],
            period: new PeriodService(),
            account: null,
            name: '',
            currentTime: [moment().format('HH'), moment().format('m')],

            morningHour: [],
            afternoonHour: [],
            minHour: 0,
            maxHour: 24,
            selectedAppointment: false,

            winh: window.innerHeight,

            myAsyncData: false,

            moveActive: false,
            itemMove: null,
            itemMoveStartMinutes: null,
            itemMoveEndMinutes: null,
            itemMoveStartPixel: 0,
            rect: null,
            directionMove: null,
            itemInitial: {
                date: null,
                time: null,
                duration: null,
            },
            currenteDate: null,
        };
    },
    computed: {
        getWinh() {
            return this.winh - 80
        },
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })

        window.addEventListener('mouseup', this.stopMoveAppointment);
    },
    beforeUnmount() { 
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        onResize() {
            this.winh = window.innerHeight
        },
        getDatetime(index, day, minutes) {
            let dt = ''
            if(index != -1) {
                dt = ' ' + (index + this.minHour - 1) + ':' + (minutes * 15) + ':00'
            }
            return moment(day).format('YYYY-MM-DD') + dt
        },
        actualDay(day) {
            if(moment().format('YYYY-MM-DD') == day) {
                return '#f9f2cb'
            }
            return 'white'
        },
        dayName(day) {
            const dt = new Date(day)
            const daysName = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']

            return daysName[dt.getDay()] + ' ' + moment(dt).format('DD/MM')
        },
        dayNameShort(day) {
            const dt = new Date(day)

            return moment(dt).format('DD')
        },
        dayNum(day) {
            return moment(new Date(day)).format('E')
        },
        addAppointment(appointment) {
            const uuid = this.$store.state.account.uuid

            if(appointment.person_uuid == 0) {
                appointment.person_uuid = null
            }

            if(!appointment.person_uuid
                && appointment.person_name
                && userService.hasPermission(RightsEnum.Person)
            ) {
                appointment.person_uuid = null

                this.$store.dispatch('account/addPerson', {
                    account_uuid: uuid,
                    name: appointment.person_name,
                    email: '',
                    phone: '',
                    note: '',
                }).then(() => {
                    appointment.person_uuid = this.$store.state.account.lastPersonAdded?.uuid

                    const lastPersonAdded = this.$store.state.account.lastPersonAdded
                    if(lastPersonAdded) {
                        let persons = this.$store.state.account.persons
                        persons[lastPersonAdded.uuid] = lastPersonAdded
                        this.$store.dispatch('account/loadPersons', persons)
                    }

                    appointmentService.create(appointment, uuid)
                    .then(data => {
                        const d = moment(data.date).format('YYYY-MM-DD');

                        data['person_uuid'] = this.$store.state.account.lastPersonAdded?.uuid

                        if(this.daysAppointments[d]) {
                            this.daysAppointments[d].push(data);
                        }

                        this.appointmentData = data
                    })
                    .catch(err => {
                        if(err.response.status == 401) {
                            this.$moshaToast("Vous n'êtes pas autorisé à créer un rendez-vous.", {
                                timeout: 3000,
                                hideProgressBar: true,
                                type: 'warning',
                                swipeClose: true,
                                position: 'top-center',
                            })
                        } else if(err.response.status == 409) {
                            this.$moshaToast("Le rendez-vous ne peut être créé à ces horaires.", {
                                timeout: 3000,
                                hideProgressBar: true,
                                type: 'warning',
                                swipeClose: true,
                                position: 'top-center',
                            })
                        } else {
                            this.$moshaToast(err.response.data.error_description, {
                                timeout: 3000,
                                hideProgressBar: true,
                                type: 'warning',
                                swipeClose: true,
                                position: 'top-center',
                            })
                        }
                    });
                })
            } else {
                appointmentService.create(appointment, uuid)
                .then(data => {
                    const d = moment(data.date).format('YYYY-MM-DD');

                    data['person_uuid'] = this.$store.state.account.lastPersonSelected.uuid
                    if(this.daysAppointments[d]) {
                        this.daysAppointments[d].push(data);
                    }

                    this.appointmentData = data

                    const lastPersonSelected = this.$store.state.account.lastPersonSelected
                    if(lastPersonSelected.uuid) {
                        let persons = this.$store.state.account.persons
                        persons[lastPersonSelected.uuid] = lastPersonSelected
                        this.$store.dispatch('account/loadPersons', persons)

                        this.appointmentData.person_uuid = lastPersonSelected.uuid
                    }
                    
                })
                .catch(err => {
                    if(err.response.status == 401) {
                        this.$moshaToast("Vous n'êtes pas autorisé à créer un rendez-vous.", {
                            timeout: 3000,
                            hideProgressBar: true,
                            type: 'warning',
                            swipeClose: true,
                            position: 'top-center',
                        })
                    } else if(err.response.status == 409) {
                        this.$moshaToast("Le rendez-vous ne peut être créé à ces horaires.", {
                            timeout: 3000,
                            hideProgressBar: true,
                            type: 'warning',
                            swipeClose: true,
                            position: 'top-center',
                        })
                    } else {
                        this.$moshaToast(err.response.data.error_description, {
                            timeout: 3000,
                            hideProgressBar: true,
                            type: 'warning',
                            swipeClose: true,
                            position: 'top-center',
                        })
                    }
                })
            }
        },
        updateAppointment(appointment) {
            const uuid = this.$store.state.account.uuid

            if(appointment.person_uuid == 0) {
                appointment.person_uuid = null
            }

            if(!appointment.person_uuid
                && appointment.person_name
                && userService.hasPermission(RightsEnum.Person)
            ) {
                this.$store.dispatch('account/addPerson', {
                    account_uuid: uuid,
                    name: appointment.person_name,
                    email: '',
                    phone: '',
                    note: '',
                }).then(() => {
                    appointment.person_uuid = this.$store.state.account.lastPersonAdded?.uuid

                    appointmentService.modify(appointment, this.$store.state.account.uuid)
                    .then(data => {
                        Object.values(this.daysAppointments).forEach((item) => {
                            item.find((o, i) => {
                                if(o.id === appointment.id) {
                                    let dtFind = moment(o.date).format('YYYY-MM-DD');
                                    this.daysAppointments[dtFind].splice(i, 1);
                                    return true;
                                }
                            });
                        });

                        data['person_uuid'] = this.$store.state.account.lastPersonAdded?.uuid

                        const dt = moment(data.date).format('YYYY-MM-DD');
                        if(this.daysAppointments[dt]) {
                            this.daysAppointments[dt].push(data);
                        }

                        const lastPersonSelected = this.$store.state.account.lastPersonSelected
                        if(lastPersonSelected.uuid) {
                            let persons = this.$store.state.account.persons
                            persons[lastPersonSelected.uuid] = lastPersonSelected
                            this.$store.dispatch('account/loadPersons', persons)

                            this.appointmentData.person_uuid = lastPersonSelected.uuid
                        }
                    })
                    .catch(err => {
                        if(err.response.status == 401) {
                            this.$moshaToast("Vous n'êtes pas autorisé à modifier les rendez-vous.", {
                                timeout: 3000,
                                hideProgressBar: true,
                                type: 'warning',
                                swipeClose: true,
                                position: 'top-center',
                            })
                        } else if(err.response.status == 409) {
                            this.$moshaToast("Le rendez-vous ne peut être modifié à ces horaires.", {
                                timeout: 3000,
                                hideProgressBar: true,
                                type: 'warning',
                                swipeClose: true,
                                position: 'top-center',
                            })
                        } else {
                            this.$moshaToast(err.response.data.error_description, {
                                timeout: 3000,
                                hideProgressBar: true,
                                type: 'warning',
                                swipeClose: true,
                                position: 'top-center',
                            })
                        }
                    });
                })
            } else {
                appointmentService.modify(appointment, this.$store.state.account.uuid)
                .then(data => {
                    Object.values(this.daysAppointments).forEach((item) => {
                        item.find((o, i) => {
                            if(o.id === appointment.id) {
                                let dtFind = moment(o.date).format('YYYY-MM-DD');
                                this.daysAppointments[dtFind].splice(i, 1);
                                return true;
                            }
                        });
                    });

                    data['person_uuid'] = this.$store.state.account.lastPersonSelected.uuid
                    const dt = moment(data.date).format('YYYY-MM-DD');
                    if(this.daysAppointments[dt])
                    {
                        this.daysAppointments[dt].push(data);
                    }

                    const lastPersonSelected = this.$store.state.account.lastPersonSelected
                    if(lastPersonSelected.uuid) {
                        let persons = this.$store.state.account.persons
                        persons[lastPersonSelected.uuid] = lastPersonSelected
                        this.$store.dispatch('account/loadPersons', persons)

                        this.appointmentData.person_uuid = lastPersonSelected.uuid
                    }
                })
                .catch(err => {
                    if(err.response.status == 401) {
                        this.$moshaToast("Vous n'êtes pas autorisé à modifier les rendez-vous.", {
                            timeout: 3000,
                            hideProgressBar: true,
                            type: 'warning',
                            swipeClose: true,
                            position: 'top-center',
                        })
                    } else if(err.response.status == 409) {
                        this.$moshaToast("Le rendez-vous ne peut être modifié à ces horaires.", {
                            timeout: 3000,
                            hideProgressBar: true,
                            type: 'warning',
                            swipeClose: true,
                            position: 'top-center',
                        })
                    } else {
                        this.$moshaToast(err.response.data.error_description, {
                            timeout: 3000,
                            hideProgressBar: true,
                            type: 'warning',
                            swipeClose: true,
                            position: 'top-center',
                        })
                    }
                })
            }
        },
        removeAppointment(appointment) {
            appointmentService.delete(appointment, this.$store.state.account.uuid)
                .then(data => {
                    const d = moment(data.date).format('YYYY-MM-DD');

                    this.daysAppointments[d].find((o, i) => {
                        if(o.id === data.id) {
                            this.daysAppointments[d].splice(i, 1);
                            return true;
                        }
                    });

                    this.appointmentData = {}
                })
                .catch(err => {
                    if(err.response.status == 401) {
                        this.$moshaToast("Vous n'êtes pas autorisé à modifier les rendez-vous.", {
                            timeout: 3000,
                            hideProgressBar: true,
                            type: 'warning',
                            swipeClose: true,
                            position: 'top-center',
                        })
                    } else if(err.response.status == 409) {
                        this.$moshaToast("Le rendez-vous ne peut être supprimé.", {
                            timeout: 3000,
                            hideProgressBar: true,
                            type: 'warning',
                            swipeClose: true,
                            position: 'top-center',
                        })
                    } else {
                        this.$moshaToast(err.response.data.error_description, {
                            timeout: 3000,
                            hideProgressBar: true,
                            type: 'warning',
                            swipeClose: true,
                            position: 'top-center',
                        })
                    }
                })
        },
        resetAppointment() {
            this.appointmentData = {}
        },
        actionOnAppointment(item) {
            this.appointmentData = item;
            this.selectedAppointment = true
        },
        changeDateAppointment(item) {
            const d = moment(this.currenteDate).format('YYYY-MM-DD')

            this.daysAppointments[d].find((o, i) => {
                if(o.id === item.id) {
                    this.daysAppointments[d].splice(i, 1);
                    return true;
                }
            });

            let itemDate = item.date
            if(item.date instanceof Date) {
                itemDate = moment(item.date).format('YYYY-MM-DD')
            }

            if(this.daysAppointments[itemDate]) {
                this.daysAppointments[itemDate].push(item);
            }

            this.currenteDate = itemDate
        },
        reloadAppointment(dates) {
            this.daysAppointments = {};

            this.period.setInterval(moment(dates[0]), moment(dates[1]));
            this.period.period.forEach(d => {
                const dt = d.format('YYYY-MM-DD');
                if(!this.daysAppointments[dt]) {
                    this.daysAppointments[dt] = [];
                }
            })

            appointmentService.get({
                date_start: this.period.period[0].format('YYYY-MM-DD'),
                date_end: this.period.period[this.period.period.length - 1].format('YYYY-MM-DD'),
            })
            .then(data => {
                let persons = []
                let appointmentsPersons = []
                if(data['persons'].length) {
                    data['persons'].forEach((el) => {
                        persons[el.person.uuid] = el.person
                    });

                    this.$store.dispatch('account/loadPersons', persons)

                    data['persons'].forEach((el) => {
                        appointmentsPersons[el.appointmentperson.appointment_uuid] = el.appointmentperson.person_uuid
                    });
                }

                if(data['appointments'].length) {
                    data['appointments'].forEach((el) => {
                        if(appointmentsPersons[el.uuid]) {
                            el.person_uuid = appointmentsPersons[el.uuid]
                        }

                        const dateString = moment(el.date).format('YYYY-MM-DD')
                        if(this.daysAppointments[dateString]) {
                            el.type = 'appointment'
                            this.daysAppointments[dateString].push(el)
                        }
                    });
                }
            });
        
            unavailabilityService.get({
                date_start: this.period.period[0].format('YYYY-MM-DD'),
                date_end: this.period.period[this.period.period.length - 1].format('YYYY-MM-DD'),
            })
            .then(data => {
                if(data['unavailabilities'].length) {
                    data['unavailabilities'].forEach((el) => {
                        const dateString = moment(el.date).format('YYYY-MM-DD')
                        if(this.daysAppointments[dateString]) {
                            el.type = 'unavailability'
                            this.daysAppointments[dateString].push(el)
                        }
                    });
                }
                if(data['unavailabilities_weekly'].length) {
                    data['unavailabilities_weekly'].forEach((el) => {
                        let mappingDateDay = []
                        Object.keys(this.daysAppointments).forEach((key) => {
                            const keyDate = moment(key)
                            mappingDateDay[keyDate.format('E')] = keyDate.format('YYYY-MM-DD')
                        })
                        const dateString = mappingDateDay[moment(el.date).format('E')]
                        //const dateString = moment(el.date).format('D')
                        if(this.daysAppointments[dateString]) {
                            el.type = 'unavailability'
                            this.daysAppointments[dateString].push(el)
                        }
                    });
                }
            });
        },
        setCurrentDate(modelData) {
            this.currentdate = modelData
            this.reloadAppointment(this.currentdate)
        },
        actionOnAgenda(event) {
            if(event.target.dataset.datetime)
            {
                const dt = moment(event.target.dataset.datetime);
                let time = null
                let dtArr = event.target.dataset.datetime.split(' ')
                if(dtArr.length > 1)
                {
                    time = dt.format("HH:mm");
                }

                this.appointmentData = {
                    date: dt.format("YYYY-MM-DD"),
                    time: time,
                    description: '',
                    duration: 30,
                    reason_id: 0,
                    place_id: 0,
                    person_uuid: null,
                };
            }
        },
        isCrossed(index, day) {
            if(this.morningHour[day - 1] > (index + this.minHour - 1)
                || this.afternoonHour[day - 1] < (index + this.minHour)) {
                return 'crossed'
            }

            return ''
        },
        eventHandler () {
            this.appointmentData = {}
        },
        eventHandlerSemainePrecedente () {
            this.currentdate = [
                moment(this.currentdate[0]).subtract(7, 'd').format('YYYY-MM-DD'),
                moment(this.currentdate[1]).subtract(7, 'd').format('YYYY-MM-DD'),
            ]
            this.setCurrentDate(this.currentdate)
        },
        eventHandlerSemaineSuivante () {
            this.currentdate = [
                moment(this.currentdate[0]).add(7, 'd').format('YYYY-MM-DD'),
                moment(this.currentdate[1]).add(7, 'd').format('YYYY-MM-DD'),
            ]
            this.setCurrentDate(this.currentdate)
        },
        eventHandlerAujourdhui () {
            this.currentdate = [
                moment().startOf('isoweek').format('YYYY-MM-DD'),
                moment().endOf('isoweek').format('YYYY-MM-DD')
            ]
            this.setCurrentDate(this.currentdate)
        },
        moveAppointment (item) {
            this.moveActive = true
            this.itemMove = ref(item)
            this.currenteDate = this.itemMove.item.date

            var div = document.getElementById('agenda-global')
            var rect = div.getBoundingClientRect()

            this.rect = rect

            const itemMovetimeArray = this.itemMove.item.time.toString().split(':')
            this.itemMoveStartMinutes = ((+itemMovetimeArray[0]) * 60 + (+itemMovetimeArray[1]))
            this.itemMoveEndMinutes = parseInt(this.itemMoveStartMinutes + this.itemMove.item.duration)

            const itemMoveStartPercent = parseFloat((this.itemMoveStartMinutes - this.itemMove.agendaStart * 60) * 100 / (this.itemMove.agendaDuration * 60)).toFixed(2)
            this.itemMoveStartPixel = this.rect.height * itemMoveStartPercent / 100

            this.itemInitial = {
                date: this.itemMove.item.date,
                time: this.itemMove.item.time,
                duration: this.itemMove.item.duration,
            }
        },
        moveUpAppointment (event, item) {
            this.moveAppointment(item)
            this.directionMove = 'up'
        },
        moveDownAppointment (event, item) {
            this.moveAppointment(item)
            this.directionMove = 'down'
        },
        moveAllAppointment (event, item) {
            this.moveAppointment(item)
            this.itemMove.item.moving = true
            this.directionMove = 'all'
        },
        async stopMoveAppointment () {
            this.moveActive = false

            if(this.itemMove
                && (this.itemMove.item.date != this.itemInitial.date
                || this.itemMove.item.time != this.itemInitial.time
                || this.itemMove.item.duration != this.itemInitial.duration)
            )
            {
                this.itemMove.item.moving = false

                let it = this.itemMove.item
                const timeArray = it.time.toString().split(':')
                it.heure = {
                    hours: (+timeArray[0]),
                    minutes: (+timeArray[1]),
                };

                await appointmentService.modify(it, this.$store.state.account.uuid)
                    .then(response => {
                        let appointmentReload = Object.assign({}, this.appointmentData);

                        appointmentReload.date = this.itemMove.item.date
                        appointmentReload.time = this.itemMove.item.time
                        appointmentReload.duration = this.itemMove.item.duration

                        this.appointmentData = appointmentReload

                        return response.data
                    })
                    .catch(err => {
                        this.itemMove.item.date = this.itemInitial.date
                        this.itemMove.item.time = this.itemInitial.time
                        this.itemMove.item.duration = this.itemInitial.duration

                        let appointmentReload = Object.assign({}, this.appointmentData);

                        appointmentReload.time = this.itemMove.item.time
                        appointmentReload.duration = this.itemMove.item.duration

                        this.appointmentData = appointmentReload

                        this.changeDateAppointment(this.itemMove.item)

                        if(err.response.status == 401)
                        {
                            this.$moshaToast("Vous n'êtes pas autorisé à modifier les rendez-vous.", {
                                timeout: 3000,
                                hideProgressBar: true,
                                type: 'warning',
                                swipeClose: true,
                                position: 'top-center',
                            })
                        } else {
                            //this.$moshaToast("Le rendez-vous ne peut être modifié avec ces paramètres.", {
                            this.$moshaToast(err.response.data.error_description, {
                                timeout: 3000,
                                hideProgressBar: true,
                                type: 'warning',
                                swipeClose: true,
                                position: 'top-center',
                            })
                        }
                    });
            }

            this.itemMove = null
            this.itemMoveStartMinutes = null
            this.itemMoveEndMinutes = null
            this.itemMoveStartPixel = 0
            this.rect = null
            this.directionMove = null
            this.itemInitial = {
                date: null,
                time: null,
                duration: null,
            }
            this.currenteDate = null
        },
        handleMouseMove(event) {
            if(this.moveActive && this.itemMove)
            {
                const div = document.getElementById('agenda-global')
                const rect = div.getBoundingClientRect()

                const child = div.querySelectorAll('.js-calendar-date')
                child.forEach((value) => {
                    const rectChild = value.getBoundingClientRect()

                    if((event.clientX - rectChild.left) > 0 && (event.clientX - rectChild.left) < rectChild.width
                        && value.dataset.date != moment(this.itemMove.item.date).format('YYYY-MM-DD')) {
                        this.itemMove.item.date = value.dataset.date
                    }
                })

                const xPixel = event.clientX - rect.left
                const yPixel = event.clientY - rect.top
                
                const itemMoveStartString = moment(this.itemMove.item.date).format('YYYY-MM-DD')
                const itemMoveStartDay = moment(this.itemMove.item.date).format('E') - 1

                const durationByYPixel = parseInt(yPixel - this.itemMoveStartPixel + 10)

                if(this.directionMove == 'up')
                {
                    const yMinutes = (this.itemMove.agendaStart * 60) + yPixel * (this.itemMove.agendaDuration * 60) / this.rect.height
                    const yString = parseInt(yMinutes / 60).toString().padStart(2, '0') + ':' + parseInt(yMinutes % 60).toString().padStart(2, '0') + ':00'
 
                    this.itemMove.item.time = yString
 
                    this.itemMove.item.duration = this.itemMoveEndMinutes - parseInt(yMinutes)

                    if(yMinutes < this.morningHour[itemMoveStartDay] * 60) {
                        const itemMoveTimeMinutes = this.morningHour[itemMoveStartDay] * 60

                        this.itemMove.item.time = this.morningHour[itemMoveStartDay].toString().padStart(2, '0') + ':00:00'
                        this.itemMove.item.duration = this.itemMoveEndMinutes - itemMoveTimeMinutes
                    }

                    let lastContactPixel = 0
                    this.daysAppointments[itemMoveStartString].forEach((item) => {
                        if(this.itemMove.item.id != item.id) {
                            const itemTimeArray = item.time.toString().split(':')
                            const itemStartMinutes = ((+itemTimeArray[0]) * 60 + (+itemTimeArray[1]))

                            const itemStartPercent = parseFloat((itemStartMinutes + item.duration - this.itemMove.agendaStart * 60) * 100 / (this.itemMove.agendaDuration * 60)).toFixed(2)
                            const itemStartPixel = this.rect.height * itemStartPercent / 100

                            if(itemStartPixel <= this.itemMoveStartPixel && itemStartPixel >= lastContactPixel) {
                                lastContactPixel = itemStartPixel

                                if(yPixel <= lastContactPixel) {
                                    const itTmMinutes = (this.itemMove.agendaStart * 60) + (lastContactPixel + 1) * (this.itemMove.agendaDuration * 60) / this.rect.height
                                    const itTmString = parseInt(itTmMinutes / 60).toString().padStart(2, '0') + ':' + parseInt(itTmMinutes % 60).toString().padStart(2, '0') + ':00'

                                    this.itemMove.item.time = itTmString
                                    this.itemMove.item.duration = this.itemMoveEndMinutes - parseInt(itTmMinutes)
                                }
                            }
                        }
                    });
                } else if(this.directionMove == 'down') {
                    this.itemMove.item.duration = parseInt((this.itemMove.agendaDuration * 60) * durationByYPixel / this.rect.height)

                    const yMinutes = (this.itemMove.agendaStart * 60) + yPixel * (this.itemMove.agendaDuration * 60) / this.rect.height

                    if(yMinutes > this.afternoonHour[itemMoveStartDay] * 60 - 5) {
                        this.itemMove.item.duration = (this.afternoonHour[itemMoveStartDay] * 60) - this.itemMoveStartMinutes
                    } else {
                        let lastContactPixel = this.rect.height
                        this.daysAppointments[itemMoveStartString].forEach((item) => {
                            if(this.itemMove.item.id != item.id) {
                                const itemTimeArray = item.time.toString().split(':')
                                const itemStartMinutes = ((+itemTimeArray[0]) * 60 + (+itemTimeArray[1]))

                                const itemStartPercent = parseFloat((itemStartMinutes - this.itemMove.agendaStart * 60) * 100 / (this.itemMove.agendaDuration * 60)).toFixed(2)
                                const itemStartPixel = this.rect.height * itemStartPercent / 100
    
                                if(itemStartPixel > this.itemMoveStartPixel && itemStartPixel < lastContactPixel) {
                                    lastContactPixel = itemStartPixel

                                    if(this.itemMoveStartPixel + durationByYPixel > lastContactPixel) {
                                        this.itemMove.item.duration = itemStartMinutes - this.itemMoveStartMinutes
                                    }
                                }
                            }
                        });
                    }
                } else if(this.directionMove == 'all') {
                    const durationPercent = parseFloat(this.itemMove.item.duration * 100 / (this.itemMove.agendaDuration * 60)).toFixed(2)
                    const durationPixel = this.rect.height * durationPercent / 100
                    const halfDurationPixel = durationPixel / 2

                    const yMinutes = (this.itemMove.agendaStart * 60) + (yPixel - halfDurationPixel) * (this.itemMove.agendaDuration * 60) / this.rect.height
 
                    this.itemMove.item.time = parseInt(yMinutes / 60).toString().padStart(2, '0') + ':' + parseInt(yMinutes % 60).toString().padStart(2, '0') + ':00'

                    const yEndMinutes = yMinutes + this.itemMove.item.duration

                    if(yMinutes < this.morningHour[itemMoveStartDay] * 60) {
                        this.itemMove.item.time = this.morningHour[itemMoveStartDay].toString().padStart(2, '0') + ':00:00'
                    } else if(yEndMinutes > this.afternoonHour[itemMoveStartDay] * 60 - 5) {
                        const itemMoveTimeMinutes = this.afternoonHour[itemMoveStartDay] * 60 - this.itemMove.item.duration

                        this.itemMove.item.time = parseInt(itemMoveTimeMinutes / 60).toString().padStart(2, '0') + ':' + parseInt(itemMoveTimeMinutes % 60).toString().padStart(2, '0') + ':00'
                    }
                }
            }
        },
    },
    //created() {},
    async beforeCreate() {
        await this.$store.dispatch('account/load').then(() => {
            const setting = this.$store.state.account.setting

            this.account = this.$store.state.account.uuid

            this.morningHour = setting.morning_hour.split(';')
            this.afternoonHour = setting.afternoon_hour.split(';')

            this.minHour = Math.min(...this.morningHour)
            this.maxHour = Math.max(...this.afternoonHour)


            this.daysAppointments = {};

            this.period = new PeriodService();

            this.period.setIntervalByDays(moment(), 7);
            this.period.period.forEach(d => {
                const dt = d.format('YYYY-MM-DD');
                if(!this.daysAppointments[dt]) {
                    this.daysAppointments[dt] = [];
                }
            })
            
            api.get('/user/' + this.$store.state.profil.user).then(response => {
                this.name = response.data.first_name + ' ' + response.data.last_name;

                return response.data;
            });

            this.eventHandlerAujourdhui()

            this.myAsyncData = true
        })
    },
}
</script>

<template>
    <div>
        <div v-if="myAsyncData" class="h-full flex">
            <div class="bg-gray-50 pt-4 overflow-y-auto h-full flex-[0_0_350px] mr-0 pr-2" :style="{'height': getWinh + 'px'}">
                <div class="mx-2">
                    <VueDatepicker
                        name="date"
                        :model-value="currentdate"
                        :enableTimePicker="false"
                        locale="fr"
                        cancelText="Annuler"
                        selectText="Valider"
                        format="dd/MM/yyyy"
                        teleport-center
                        :typeable="true"
                        text-input
                        auto-apply
                        inline
                        week-picker
                        @update:model-value="setCurrentDate"
                        class="flex justify-center"
                        :month-change-on-scroll="false"
                        />

                    <AppointmentForm
                        :externData="appointmentData"
                        @add-appointment="addAppointment"
                        @update-appointment="updateAppointment"
                        @remove-appointment="removeAppointment"
                        @reset-appointment="resetAppointment"
                    />
                </div>
            </div>
            <div
                class="relative overflow-y-auto h-full flex-auto ml-3 mr-0 pr-2"
                :style="{'height': getWinh + 'px'}"
            >
                <div class="absolute">
                    <div class="fixed h-[49px] bg-white z-[1500]" style="width: calc(100% - 375px); z-index: 1800">
                        <Control
                            :dateInterval="currentdate"
                            @eventName="eventHandler"
                            @eventNameSemainePrecedente="eventHandlerSemainePrecedente"
                            @eventNameSemaineSuivante="eventHandlerSemaineSuivante"
                            @eventNameAujourdhui="eventHandlerAujourdhui"
                            @eventNameReload="reloadAppointment"
                        />
                    </div>
                </div>

                <div class="absolute">
                    <section class="opacity-95 bg-orange-100 fixed z-[1500] flex justify-center mt-12 ml-1 bg-white" style="width: calc(100% - 378px); z-index: 1800">
                        <div class="w-[148px] relative calendar border-none" style="border-right: 1px solid #555"></div>
                        <div v-for="(appointments, day) in daysAppointments"
                            v-bind:key="day"
                            class="w-full flex border-y border-black last:border-r"
                            >

                            <div
                                class="text-xs mx-auto my-1 py-1 px-0 lg:px-2 rounded-lg hover:cursor-pointer hover:bg-gray-200"
                                :style="{'background-color': actualDay(day)}"
                                :data-datetime="getDatetime(-1, day, 0)"
                                @click="actionOnAgenda">
                                <icon name="plus" :size="30" color="black" />
                                <span class="hidden lg:block" :data-datetime="getDatetime(-1, day, 0)">{{ dayName(day) }}</span>
                                <span class="block lg:hidden" :data-datetime="getDatetime(-1, day, 0)">{{ dayNameShort(day) }}</span>
                            </div>
                        </div>
                    </section>
                </div>

                <section
                    id="agenda-global"
                    @mousemove="handleMouseMove($event)"
                    class="relative flex m-1 border-r border-b border-[#555] mt-[81px]"
                >
                    <CurrentTime :agendaStart="minHour" :agendaDuration="maxHour - minHour" />

                    <div class="w-40 relative calendar">
                        <div class="absolute w-full h-full">
                            <div v-for="index in (maxHour - minHour)" :key="index" class="cell flex">
                                <span class="text-[11px]">
                                    {{ (index - 1 + minHour).toString().padStart(2, "0") }}h
                                </span>
                            </div>
                        </div>
                    </div>

                    <div v-for="(appointments, day) in daysAppointments"
                        v-bind:key="day"
                        class="w-full calendar js-calendar-date"
                        :style="{'background-color': actualDay(day)}"
                        @click="actionOnAgenda"
                        :data-date="day"
                    >
                        <div class="relative">
                            <div class="absolute w-full h-full">
                                <div v-for="item in appointments" v-bind:key="item">
                                    <UnavailabilityItem
                                        v-if="item.type == 'unavailability'"
                                        :item="item"
                                        :agendaStart="minHour"
                                        :agendaDuration="maxHour - minHour"
                                    />
                                    <AppointmentItem
                                        v-else
                                        :item="item"
                                        :agendaStart="minHour"
                                        :agendaDuration="maxHour - minHour"
                                        :selected="appointmentData?.id"
                                        @select-item="actionOnAppointment(item)"
                                        @change-date="changeDateAppointment(item, oldVal, newVal)"
                                        @remove-appointment="removeAppointment"
                                        @move-down-appointment="moveDownAppointment"
                                        @move-up-appointment="moveUpAppointment"
                                        @move-all-appointment="moveAllAppointment"
                                        @stop-move-appointment="stopMoveAppointment"
                                    />
                                </div>
                            </div>

                            <div v-for="index in (maxHour - minHour)" :key="index">
                                <div :class="[`index--${index}`, isCrossed(index, dayNum(day))]" class="cell">
                                    <div v-if="isCrossed(index, dayNum(day)) == ''" class="h-1/4 text-[6px] border-b border-[#e0e0e0] cell-choix" :data-datetime="getDatetime(index, day, 0)"></div>
                                    <div v-if="isCrossed(index, dayNum(day)) == ''" class="h-1/4 text-[6px] border-b border-[#393939] border-dashed cell-choix" :data-datetime="getDatetime(index, day, 1)"></div>
                                    <div v-if="isCrossed(index, dayNum(day)) == ''" class="h-1/4 text-[6px] border-b border-[#e0e0e0] cell-choix" :data-datetime="getDatetime(index, day, 2)"></div>
                                    <div v-if="isCrossed(index, dayNum(day)) == ''" class="h-1/4 text-[6px] border-b border-[#e0e0e0] border-none cell-choix" :data-datetime="getDatetime(index, day, 3)"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </div>
        <div
            v-else
            class="h-screen flex flex-col items-center justify-center text-xl"
        >
            <img alt="Loading" src="/loading.gif" width="125" height="125" />
            Chargement...
        </div>
    </div>
</template>

<style scoped>

.wrapper {
    position: relative;
    width: 1280px;
    z-index: auto;
}
.cellule {
    margin: 0px;
    display: table;
    font-size: 8px;
}

.cellule span { margin: 5px; }

.cellule .case {
    border-bottom: solid black 1px;
    height: 30px;
}
.cellule .case:last-child {
    border-bottom: none;
}

.cellule .case:first-child:hover {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.case-2 {
    height: 15px;
}

.cellule .case:first-child:hover > .case-2:first-child:hover {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.cellule > .case:last-child:hover > .case-2:last-child:hover {
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
} 

.cellule .case-choix:hover, .cellule .case-choix-2:hover {
    background-color: #dedede;
    cursor: pointer;
}

.calendar:last-child .cell { border-right: none; }

.cell {
    border-top: solid 1px #555;
    border-right: solid 1px #555;
    height: 100px;
    position: relative;
    margin: 0;
    display: flex;
    flex-direction: column;
}

.cell-jour-top {
    border-top: solid 1px #555;
    border-bottom: solid 1px #555;
    height: 100px;
    position: relative;
    margin: 0;
    display: flex;
    flex-direction: column;
}

/* cell par défaut : grisé, surcharge choix en blanc */
.cell-empty {
        border-top: solid 1px #fff;
        border-right: solid 1px #555;
        height: 40px;
        position: relative;
    }

    /*&-empty + &-choix, */.cell:nth-child(2) {
        border-top: solid 1px #555;
    }

.cell-choix + .cell-empty, .cell-non + .cell-empty { border-top: solid 1px #777; }

.cell-jour {
    border-top: none;
    font-size: 11px;
    display: flex;
    height: 25px;
}

.cell-liste-jour {
    margin-top: 45px;
    border-top: 1px solid #555;
}


.cell-jour span{ margin: auto; }

.cell-choix:hover, .cell-choix-2:hover, .cell-jour:hover {
    background-color: #dedede;
    cursor: pointer;
}

.cell-select { background-color: #f7f7f7; }

.cell-non { background-color: #a4a4a4; }

.cell-non:first-of-type {
    border: solid 1px deeppink;
    background-color: chartreuse;
}

.modal__title {
  font-size: 1.5rem;
  font-weight: 700;
}

.crossed {
     background: 
     repeating-linear-gradient(
        45deg,
        #dadada 0px,
        #dadada 3px,
        #ffffff 3px,
        #ffffff 12px
    );
}

</style>
